import { render, staticRenderFns } from "./p3.vue?vue&type=template&id=e95245e4&scoped=true&"
import script from "./p3.vue?vue&type=script&lang=js&"
export * from "./p3.vue?vue&type=script&lang=js&"
import style0 from "./p3.vue?vue&type=style&index=0&id=e95245e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95245e4",
  null
  
)

export default component.exports